export class CloseEmailModalEvent {}
